import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { Customer, Project, Paper, allProject } from './interface'
import { getCustomerList, getDissertationList, getOrderCourseListByCustomerId, getDissertationIdCommissionType, setFinanceOrder, getFinanceOrderById, setFinanceOrderById, getCompanyList } from '@/api/financial-center'
import { getDraftById, setDraftById } from '@/api/draft'
import { delNullProperty } from '@/utils/index'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    filters: {
        commissionType: (val: string) => {
            let str = ''
            switch (val) {
                case '0':
                    str = '暂无'
                    break;
                case '1':
                    str = '结算价'
                    break;
                case '2':
                    str = '返点'
                    break;
                default:
                    str = ''
                    break;
            }
            return str
        }
    },
    components:{
        MoreUsersFilter
    }
})
export default class NewPaperOrder extends Vue {
    editShow = false
    disabledButton = false
    isDraft = '0'
    orderId: number = null
    draftId: number = null
    changeData = false

    projectDissertationId: number = null
    projectDialogShow = false
    errorDialogShow = false
    dialogProjectInputValue = ''
    projectDialogTableData = []
    projectDialogCheckedTable: Project = {
        projectAllId: undefined,
        souCourseIndex: '',
        souCourseName: '',
        souCoursePrice: '',
        souCourseSchoolBegin: '',
        souCourseType: '',
        status: '',
        surplusQuota: undefined
    }
    projectDialogTableLoading = false
    dialogProjectPage = 1
    dialogProjectTotal = 0
    dialogProjectLimit = 20

    saveDraftDialogShow = false
    paperCommissionType = '0';
    ratioPrice = 0;
    souCoursePrice = 0; //项目终端售价
    formModel = {
        customerName: '', // 客户名称
        project: '', // 主项目
        type_name: '', //论文类型
        settlementPrice: '', // 结算价
        thisRebateRatio: '', // 返点比例
        discountAmount: 0, // 优惠金额
        sellingPrice: 0, // 合计金额
        isIPQ: '0', // IPQ辅导服务
        remark: '', // 备注
        runesName: '', // 送生顾问
        directorUserId: '', // 负责人
        department: '', // 部门
        createUserName: '', // 创建人
        createAt: new Date(),
        price: '',
        projectAllId: 0,
        companyName:'', //所属公司
    }
    oldFormData: any = null
    name: string = ''
    customerNameLimit = 20
    directorUserName = ''

    discountAmountRules(rule, value, callback) {
        if(this.customerInfo.marketCooperationId === 0) {
            if(this.souCoursePrice) {
                if(Number(value) > Number(this.souCoursePrice)) {
                    callback(new Error('优惠金额不能大于项目终端售价'))
                    return
                }
                return
            } else {
                if(Number(value) > Number(this.souCoursePrice)) {
                    callback(new Error('优惠金额不能大于项目终端售价'))
                    return
                }
            }
        } else {
            if(this.customerInfo.commissionType === '1') {
                if(Number(value) > Number(this.customerInfo.priceOrRatio)) {
                    callback(new Error('优惠金额不能大于结算价'))
                    return
                }
            } else {
                if(this.souCoursePrice) {
                    if(Number(value) > Number(this.souCoursePrice)) {
                        callback(new Error('优惠金额不能大于项目终端售价'))
                        return
                    }
                } else {
                    if(Number(value) > Number(this.souCoursePrice)) {
                        callback(new Error('优惠金额不能大于项目终端售价'))
                        return
                    }
                }
            }
        }
        callback()
    }

    formRules = {
        customerName: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
        type_name: [{ required: true, message: '请选择论文类型', trigger: 'change' }],
        project: [{ required: true, message: '请选择主项目', trigger: 'change' }],
        // settlementPrice: [{ required: true, message: '请输入结算价', trigger: 'blur' }],
        // thisRebateRatio: [{ required: true, message: '请输入本单返点比例', trigger: 'change' }],
        directorUserId: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        companyName: [{ required: true, message: '请选择所属公司', trigger: 'change' }],
        // discountAmount: [{ validator: this.discountAmountRules, trigger: 'blur' }]
    }

    customerList: Customer[] = []
    customerListLoading = false
    companyListLoading = false //所属公司
    companyList = []
    paperTypeList: Paper[] = []
    allProject: allProject[] = []
    paperInfo: Paper = {
        projectDissertationId: undefined,
        price: '',
        id: null
    }
    allProjectInfo: allProject = {
        projectAllId: undefined,
        id: null
    }
    customerInfo: Customer = {
        customerId: undefined,
        customerName: '',
        customerSource: '',
        customerSourceType: '',
        customerType: '',
        marketCooperationId: undefined
    }
    loading = false

    projectInfo = {

    }
    // isReadonly = false
    timer = null

    get userName() {
        if(this.formModel.createUserName) return this.formModel.createUserName
        return UserModule.userName
    }

    get userId() {
        return UserModule.userId
    }

    get department() {
        return UserModule.department
    }

    created() {
        this.getCustomerList()
        this.getDissertationList()
        this.getCompanyList() //所属公司列表
        // 详情
        if(this.$route.query.orderId) {
            this.orderId = Number(this.$route.query.orderId)
            this.editShow = true
            this.getFinanceOrderById()
        }
        // 草稿
        if(this.$route.query.draftId) {
            this.draftId = Number(this.$route.query.draftId)
            this.getDraftById()
        }
    }
    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }

    // 草稿箱
    async getDraftById() {
        const res: any = await getDraftById(this.draftId)
        const data = res.result
        this.projectDissertationId = data.projectDissertationId
        this.customerInfo.commissionType = data.commissionType
        this.customerInfo.customerId = data.customerId
        this.customerInfo.customerName = data.customerName
        this.customerInfo.customerType = data.customerType
        this.customerInfo.customerSource = data.source
        this.customerInfo.customerSourceType = data.sourceType === '1' ? '合作伙伴' : '普通来源'
        this.customerInfo.marketCooperationId = data.marketCooperationId
        this.customerInfo.priceOrRatio = data.priceOrRatio
        this.formModel.thisRebateRatio = data.priceOrRatio
        this.formModel.customerName = data.customerName
        this.formModel.companyName = data.companyName //所属公司
        this.formModel.runesName = data.financeOrderUser.adviser
        this.formModel.createUserName = data.financeOrderUser.createdUserRealName
        this.formModel.department = data.financeOrderUser.directorDepartmentlName
        this.formModel.isIPQ = data.haveIPQ
        this.formModel.discountAmount = data.discountPrice
        this.formModel.sellingPrice = data.price
        this.formModel.project = data.souCourseName
        this.formModel.projectAllId = data.projectAllId
        this.formModel.createAt = data.createdAt
        this.formModel.remark = data.remark
        this.projectDialogCheckedTable.souCourseName = data.souCourseName
        this.souCoursePrice = data.souCoursePrice
        // this.allProjectInfo.projectAllId = data.projectAllId
        this.formModel.type_name = data.projectDissertationName
        this.formModel.directorUserId = data.financeOrderUser.directorUserId
        this.directorUserName = data.financeOrderUser.directorUserRealName
        this.clickProjectDialogConfirmButton()
    }
    // 订单详情
    async getFinanceOrderById() {
        this.loading = true
        await getFinanceOrderById({ id: this.orderId, isUpdatedData: '0' }).then((res: any)=>{
            this.loading = false
        const data = res.financeOrder
        this.oldFormData = data // 将旧数据那一份下来，用于对比是否改变 项目 或 金额
        this.customerInfo.commissionType = data.commissionType
        this.customerInfo.customerId = data.customerId
        this.customerInfo.customerName = data.customerName
        this.formModel.type_name = data.projectDissertationName
        this.paperCommissionType = data.commissionType
        this.customerInfo.customerType = data.customerType
        this.customerInfo.customerSource = data.source
        this.customerInfo.customerSourceType = data.sourceType === '1' ? '合作伙伴' : '普通来源'
        this.customerInfo.marketCooperationId = data.marketCooperationId
        this.customerInfo.priceOrRatio = data.priceOrRatio
        this.formModel.thisRebateRatio = data.priceOrRatio
        this.formModel.customerName = data.customerName
        this.formModel.directorUserId = data.financeOrderUser.directorUserId
        this.directorUserName = data.financeOrderUser.directorUserRealName
        this.formModel.runesName = data.financeOrderUser.adviser
        this.formModel.createUserName = data.financeOrderUser.createdUserRealName
        this.formModel.department = data.financeOrderUser.directorDepartmentlName
        this.formModel.isIPQ = data.haveIPQ
        this.formModel.discountAmount = data.discountPrice
        this.formModel.sellingPrice = data.price
        this.formModel.project = data.souCourseName
        this.formModel.projectAllId = data.projectAllId
        this.formModel.createAt = data.createdAt
        this.formModel.remark = data.remark
        this.formModel.companyName = data.companyName
        this.projectDialogCheckedTable.souCourseName = data.souCourseName
        this.souCoursePrice = data.souCoursePrice
        // this.projectDialogCheckedTable.projectAllId = data.projectAllId
        this.allProjectInfo.projectAllId = data.projectAllId
        this.projectDissertationId = data.projectDissertationId
        this.clickProjectDialogConfirmButton()
        if(this.customerInfo.customerSourceType == '合作伙伴') {
            this.getDissertationIdCommissionType();
        }
        }).catch(err=>{
            this.loading = false
        })
    }
    // 客户名称
    async getCustomerList() {
        const data: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
        this.customerList = [...this.customerList, ...data.customerList]
        let result = []
        let obj = {}
        for (let i = 0; i < this.customerList.length; i++) {
            if (!obj[this.customerList[i].customerId]) {
                result.push(this.customerList[i]);
                obj[this.customerList[i].customerId] = true;
            }
        }
        this.customerList = result
    }

    clearCustomer() {
        // this.formModel.customerId = null
        this.formModel.customerName = ''
        this.name = ''
        this.customerNameLimit = 20
        this.getCustomerList()
    }

    clearCustomerList(e) {
        if (!this.formModel.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            this.getCustomerList()
        }
    }

    loadmore() {
        this.customerNameLimit += 20;
        this.getCustomerList();
    }

    async remoteMethod(query: any) {
        this.name = query
        this.customerNameLimit = 20
        if (query !== '') {
            const result: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
            this.customerList = result.customerList
        } else {
              this.customerList = []
            this.getCustomerList();
        }
    }

    customerChange(val) {
        this.formModel.customerName = val.customerName
        // this.formModel.customerId = this.customerList.find(item => item.customerName === val.customerName).customerId
        if (val) {
            this.customerInfo = this.customerList.filter(item => (item.customerId === val.customerId && item.customerType === val.customerType))[0]
        } else {
            this.customerInfo = {
                customerId: undefined,
                customerName: '',
                customerSource: '',
                customerSourceType: '',
                customerType: '',
                marketCooperationId: undefined
            }
        }
    }

    async getFoucsCustomerList() {
        if (this.customerList.length == 0 && !this.formModel.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            const result: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
            this.customerList = result.customerList
        }
        if (this.formModel.customerName) {
            this.customerList = []
            this.customerNameLimit = 20
            const result: any = await getCustomerList({
                limit: this.customerNameLimit,
                customerName: this.formModel.customerName
            })
            this.customerList = result.customerList
        }
    }

    // 论文类型
    async getDissertationList() {
        const data: any = await getDissertationList()
        this.paperTypeList = data.dissertationList
    }

    typeNameChange(val: number){
        this.projectDissertationId = val
        const item = this.paperTypeList.find((p) => {
            if (p.id == val) {
              return p
            }
        })
        this.projectDissertationId = item.id
        this.souCoursePrice = Number(item.price)
        if(this.customerInfo.customerSourceType == '合作伙伴') {
            this.getDissertationIdCommissionType();
        }
        this.totalOrderAmount();
        this.getOrderCourseListByCustomer()
    }
    // 合作伙伴获取佣金类型
    async getDissertationIdCommissionType() {
        const data: any = await getDissertationIdCommissionType({
            marketCooperationId: this.customerInfo.marketCooperationId,  //合作伙伴id
            projectDissertationId: this.projectDissertationId  //论文项目id
        })
        this.paperCommissionType = data.commissionType
        if(this.paperCommissionType == '1'){
            this.formModel.settlementPrice = data.priceOrRatio
        }
        if(this.paperCommissionType == '2'){
            const price = Number(this.souCoursePrice) //终端售价
            this.formModel.thisRebateRatio = data.priceOrRatio   //返点比例
            const ratio_price = (Number(this.formModel.thisRebateRatio) * price) / 100 //返点金额=返点比例*终端售价
            this.ratioPrice = Number(ratio_price.toFixed(2))
        }
        this.totalOrderAmount();
        // commissionType: "1"
        // priceOrRatio: "21"
    }
    async getOrderCourseListByCustomer() {
        this.projectDialogTableLoading = true

        const obj = {
            customerType: this.customerInfo.customerType,
            customerId: this.customerInfo.customerId,
            souCourseName: this.dialogProjectInputValue
        }

        const data: any = await getOrderCourseListByCustomerId(delNullProperty(obj))
        this.projectDialogTableData = data.financeOrderCourseList
        this.projectDialogTableData.forEach(item => {
            if (item.projectAllId == this.formModel.projectAllId) {
                (this.$refs['dialogProjectTable'] as HTMLFormElement).toggleRowSelection(item)
            }
        })

        this.projectDialogTableLoading = false
        // this.isReadonly = false
    }
    handleOrderRowClick(row){
        (this.$refs.dialogProjectTable as HTMLFormElement).toggleRowSelection(row)
    }
    projectInputFocus() {
        if (this.customerInfo.marketCooperationId === undefined) {
            this.$message.error('请选择客户')
            return
        }
        this.projectDialogShow = true
        this.getOrderCourseListByCustomer()
    }

    dialogProjectTableCheckedChange(selection) {
        this.projectDialogCheckedTable = selection[0]
        const dom = this.$refs.dialogProjectTable as HTMLFormElement
        if (selection.length > 1) {
            dom.clearSelection();
            dom.toggleRowSelection(selection.pop());
        }
        // if (this.projectDialogCheckedTable) {
        //     this.formModel.project = this.projectDialogCheckedTable.souCourseName
        //     this.allProjectInfo.projectAllId = this.projectDialogCheckedTable.projectAllId
        // }
    }
    allProjectChange(val: number){
        const items = this.allProject.find((s) => {
            if (s.id == val) {
              return s
            }
        })
        this.allProjectInfo.projectAllId = items.id
    }

    async clickProjectDialogConfirmButton() {
        this.projectDialogShow = false
        if(this.customerInfo.marketCooperationId !== 0) {
            const data: any = await getDissertationIdCommissionType({
                marketCooperationId: this.customerInfo.marketCooperationId,
                projectDissertationId: this.projectDissertationId
            })
            this.customerInfo.commissionType = data.commissionType
            this.customerInfo.priceOrRatio = data.priceOrRatio
            if(data.commissionType === '1') this.formModel.settlementPrice = data.priceOrRatio
            if(data.commissionType === '2') {
                this.formModel.thisRebateRatio = data.priceOrRatio
                // if(this.souCoursePrice.includes('/')) {
                //     this.customerInfo.ratioPrice = Number(this.souCoursePrice.split('/')[0]) * (this.customerInfo.priceOrRatio / 100)
                // } else {
                //     this.customerInfo.ratioPrice = Number(this.souCoursePrice) * (this.customerInfo.priceOrRatio / 100)
                // }
            }
        }
        this.projectDialogTableData.forEach(item => {
            if (item.projectAllId == this.projectDialogCheckedTable.projectAllId) {
                this.formModel.project = item.souCourseName
                this.formModel.projectAllId = item.projectAllId
            }
        })
        this.sellingPriceComputed()
        this.$forceUpdate()
    }
    totalOrderAmount(){
        const souCoursePrice = Number(this.souCoursePrice)  //项目终端售价：
        const settlementPrice = Number(this.formModel.settlementPrice) //结算价：
        const ratioPrice = Number(this.ratioPrice) //本单返点金额：
        const salePrice = Number(this.formModel.discountAmount) //优惠金额：
        const thisRebateRatio = Number(this.formModel.thisRebateRatio)  //返点比例
        if(this.paperCommissionType == '1'){
            this.formModel.sellingPrice =  settlementPrice - salePrice
        }
        if(this.paperCommissionType == '2'){
            this.formModel.sellingPrice = souCoursePrice - salePrice   //订单金额合计=终端售价-优惠
            const ratio_price = thisRebateRatio * souCoursePrice / 100
            this.ratioPrice = Number(ratio_price.toFixed(2))  //返点金额=返点比例*终端售价
        }
        if(this.paperCommissionType == '0'|| this.customerInfo.customerSourceType == '普通来源'){
            this.formModel.sellingPrice =  souCoursePrice - salePrice
        }
    }
    sellingPriceComputed() {
        this.totalOrderAmount();

    }
    thisRebateRatioChange(val) {
        this.formModel.thisRebateRatio = val
        this.customerInfo.priceOrRatio = val
        if(this.souCoursePrice) {
            this.ratioPrice = Number(this.souCoursePrice) * (this.customerInfo.priceOrRatio / 100)
        } else {
            this.ratioPrice = Number(this.souCoursePrice) * (this.customerInfo.priceOrRatio / 100)
        }
        this.sellingPriceComputed()
    }
    clickSubmitButton() {
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                let priceOrRatio = ''
                if(this.paperCommissionType == '1'){
                    priceOrRatio = this.formModel.settlementPrice
                }
                if(this.paperCommissionType == '2'){
                    priceOrRatio = this.formModel.thisRebateRatio
                }

                if (this.customerInfo.customerType == 'customerBusiness' && this.formModel.runesName == '') {
                    this.$message.error('请填写送生顾问')
                    return
                }

                if(this.orderId) {
                    const obj = {
                        id: this.orderId,
                        // projectAllId: this.allProjectInfo.projectAllId,
                        projectAllId: this.formModel.projectAllId,
                        souCoursePrice: String(this.souCoursePrice),
                        commissionType: this.paperCommissionType,
                        priceOrRatio: priceOrRatio,
                        discountPrice: String(this.formModel.discountAmount),
                        haveIPQ: '0',
                        remark: this.formModel.remark,
                        adviser: this.formModel.runesName,
                        directorUserId: this.formModel.directorUserId,
                        price: String(this.formModel.sellingPrice),
                        projectDissertationId: this.projectDissertationId,
                        //    增加是否选择双课题备注字段
                        // isDoubleSouCourseName: '0',
                        companyName: this.formModel.companyName,
                        souCourseName: this.formModel.project,
                    }
                    this.disabledButton = true
                    setFinanceOrderById(obj).then(() => {
                        this.$message.success('编辑订单成功，页面即将关闭')
                        setTimeout(() => {
                            window.close()
                        }, 1500)
                    }).catch((err: Error) => {
                        if (err) {
                            this.disabledButton = false
                        }
                        if(err.message === '审批流报错') {
                            this.errorDialogShow = true
                        }
                    })
                } else {

                    const obj = {
                        customerId: this.customerInfo.customerId,
                        customerType: this.customerInfo.customerType,
                        sourceType: this.customerInfo.customerSourceType == '普通来源' ? '0' : '1',
                        source: this.customerInfo.customerSource,
                        // projectAllId: this.allProjectInfo.projectAllId,
                        projectAllId: this.formModel.projectAllId,
                        souCoursePrice: String(this.souCoursePrice),
                        commissionType: this.paperCommissionType,
                        priceOrRatio: priceOrRatio,
                        discountPrice: String(this.formModel.discountAmount),
                        price: this.formModel.sellingPrice || this.formModel.sellingPrice == 0 ? String(this.formModel.sellingPrice) : '',
                        haveIPQ: '0',
                        remark: this.formModel.remark,
                        createdUserId: this.userId,
                        adviser: this.formModel.runesName,
                        directorUserId: this.formModel.directorUserId,
                        isDraft: this.isDraft,
                        isDissertation: '1',
                        projectDissertationId: this.projectDissertationId,
                        marketCooperationId: this.customerInfo.marketCooperationId,
                        //    增加是否选择双课题备注字段
                        isDoubleSouCourseName: '0',
                        companyName: this.formModel.companyName, //所属公司
                        souCourseName: this.formModel.project,
                    }
                    this.disabledButton = true
                    setFinanceOrder(delNullProperty(obj)).then(() => {
                        this.$message.success(this.isDraft === '0' ? '新建订单成功，页面即将关闭' : '订单已保存到草稿箱')
                        setTimeout(() => {
                            window.close()
                        }, 1500)
                    }).catch((err: Error) => {
                        if (err) {
                            this.disabledButton = false
                        }
                        if(err.message === '审批流报错') {
                            this.errorDialogShow = true
                        }
                    })
                }
            }
        })
    }
    closePage() {
        window.close()
    }
    // 存草稿
    clickSaveDraftButton() {
        // TODO 点击存草稿按钮
        this.saveDraftDialogShow = true
    }

    saveDraftDialogConfirm() {
        this.isDraft = '1'
        this.clickSubmitButton()
        this.saveDraftDialogShow = false
    }

    saveDraftDialogCancel() {
        this.isDraft = '0'
        this.saveDraftDialogShow = false
    }

    projectPageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.dialogProjectPage = page
            this.getOrderCourseListByCustomer()
        }, 1000)
    }
    projectLimitChange(limit: number) {
        this.dialogProjectLimit = limit
        this.getOrderCourseListByCustomer()
    }

    // directorUserIdChange(val) {
    //     const selectedItem = this.userList.find(item => item.id === val);
    //     this.formModel.department = selectedItem.departmentName
    // }

    clickEditSaveButton(type: '0' | '1') {
        let priceOrRatio = ''
        if(this.paperCommissionType == '1'){
            priceOrRatio = this.formModel.settlementPrice
        }
        if(this.paperCommissionType == '2'){
            priceOrRatio = this.formModel.thisRebateRatio
        }
        const obj = {
            id: this.orderId,
            // projectAllId: this.allProjectInfo.projectAllId,
            projectAllId: this.formModel.projectAllId,
            souCoursePrice: String(this.souCoursePrice),
            commissionType: this.paperCommissionType,
            priceOrRatio: priceOrRatio,
            discountPrice: String(this.formModel.discountAmount),
            haveIPQ: '0',
            remark: this.formModel.remark,
            companyName: this.formModel.companyName, //所属公司
            adviser: this.formModel.runesName,
            directorUserId: this.formModel.directorUserId,
            price: String(this.formModel.sellingPrice),
            projectDissertationId: this.projectDissertationId,
        }
        this.disabledButton = true
        setDraftById({id: this.draftId, form: obj, isSubmit: type}).then(() => {
            // this.$message.success('草稿编辑成功')
            if(type === '0') {
                this.$message.success('草稿编辑成功，页面即将关闭')
            } else {
                this.$message.success('草稿提交成功，页面即将关闭')
            }
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            if(type === '1') {
                if(err.message === '审批流报错') {
                    this.errorDialogShow = true
                }
            }
            this.disabledButton = false
        })
    }

    changeDirectorUserId(e) {
        this.formModel.directorUserId = e.id
        if (e.id) {
            // const selectedItem = this.userList.find(item => item.id === e.id);
            this.formModel.department = e.departmentName
        }
    }

    @Watch('userId')
    handleUserIdChange() {
        if (!this.formModel.directorUserId) {
            this.formModel.directorUserId = this.userId
        }
    }

    @Watch('userName')
    handleUserNameChange() {
        if (!this.directorUserName) {
            this.directorUserName = this.userName
        }
    }

    @Watch('department')
    handleDepartmentChange() {
        if(!this.formModel.department) {
            this.formModel.department = this.department
        }
    }


    @Watch('formModel.sellingPrice', { deep: true })
    handleSellingPriceChange(newVal) {
        // 在金额改变的时候将 changeData  变为 true
        if(newVal != this.oldFormData.price) {
            this.changeData = true
        } else {
            this.changeData = false
        }
    }

    @Watch('projectDialogCheckedTable.projectAllId', { deep: true })
    handleProjectChange(newVal) {
        if(this.oldFormData.projectAllId != newVal) {
            this.changeData = true
        } else {
            this.changeData = false
        }
    }

}
